import { Group, Stack, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { VerifyOffer } from './VerifyOffer';
import classes from './VerifyCallout.module.css';

const VERDICT = "Couldn't verify this selection.";
const ACTION_LABEL = 'Would you like me to remove it from the document?';

type VerifyCalloutProps = {
  /** Hands the verify context off to the normal document editor pass. */
  onAction: () => void;
  /** Sidebar is dark (Siesta chats): use light text against the dark background. */
  dark?: boolean;
};

/** Shown only when the transcript has no evidence at all — the sole "couldn't verify" state. */
export function VerifyCallout({ onAction, dark }: VerifyCalloutProps) {
  return (
    <Stack gap="sm">
      <Group gap="xs" align="flex-start" wrap="nowrap">
        <IconAlertTriangle
          size={14}
          stroke={1.5}
          color="var(--mantine-color-dimmed)"
          className={classes.icon}
          aria-hidden
        />
        <Text size="textSm" c={dark ? 'gray.2' : 'gray.8'}>
          {VERDICT}
        </Text>
      </Group>
      <VerifyOffer label={ACTION_LABEL} dark={dark} onClick={onAction} />
    </Stack>
  );
}
